import React, { PropsWithChildren } from "react";
import siteConfig from "../../config/siteConfig";
import { SanityImageSourceExt } from "../../models/shared/SanityImageSourceExt";
import { validImage } from "../../utilities/image";
import BackgroundBlockPattern, {
  BackgroundBlockPatternType
} from "../BackgroundBlockPattern";
import imageBuilder from "../sanity/imageBuilder";
import { BannerColorTheme, getBannerColorTheme } from "./Common";

export interface BannerContainerProps {
  colorTheme?: BannerColorTheme;
  backgroundImage?: SanityImageSourceExt;
  backgroundPattern?: BackgroundBlockPatternType;
}

const BannerContainer: React.FC<PropsWithChildren<BannerContainerProps>> = props => {
  const { backgroundPattern, children, colorTheme, backgroundImage } = props;

  const { backgroundColor } = getBannerColorTheme(colorTheme ?? BannerColorTheme.Default);

  let containerClassNames = "max-w-none px-0 relative overflow-hidden";
  let backgroundImageStyle: string | undefined = undefined;

  if (siteConfig.isGroup) {
    // Use image as an overlayed background image for the group site
    if (validImage(backgroundImage)) {
      // TODO: width, height..?
      const imageUrl = imageBuilder(backgroundImage)
        .width(2560)
        .height(1440)
        .fit("scale")
        .auto("format")
        .url({ friendlyFilename: true });

      backgroundImageStyle = `url("${imageUrl}")`;
      containerClassNames += " bg-cover";
    } else {
      containerClassNames += ` ${backgroundColor}`;
    }
  } else {
    containerClassNames += ` lg:slice-both lg:z-1 ${backgroundColor}`;
  }

  return (
    <aside
      className={containerClassNames}
      style={{
        ...(backgroundImageStyle && { backgroundImage: backgroundImageStyle })
      }}
    >
      {
        // Only use bg-overlay if the banner has default theme. variant 2 (light blue) should look the same both for group and market.
        siteConfig.isGroup && colorTheme === BannerColorTheme.Default && (
          <div className="absolute bg-hero-overlay inset-0"></div>
        )
      }
      {backgroundPattern && (
        <BackgroundBlockPattern
          {...backgroundPattern}
          zIndexClass="z-10"
          margins={{
            baseBlockMarginTop: "9rem",
            rightBlockMarginLeft: "-8rem"
          }}
        />
      )}
      <div className="relative z-20 py-12 lg:py-40 px-6">{children}</div>
    </aside>
  );
};

export default BannerContainer;
